<template>
  <div class="locale-selector">
    <template v-for="(lang, $index) in filteredLanguages">
      <span
        v-if="$index !== 0"
        :key="`${lang}__separator`"
        class="locale-selector__separator"
      >
        |
      </span>
      <a
        :key="`${lang}__link`"
        role="button"
        @click.prevent="setLanguage(lang)"
      >
        {{ $t(lang.toUpperCase()) }}
      </a>
    </template>
  </div>
</template>

<script>
import { LANGUAGE, AVAILABLE_LANGUAGES } from '@/store/types';
import { mapGetters, mapActions } from 'vuex';
import lang from '@/mixins/lang';

export default {
  name: 'LocalSelector',
  mixins: [lang],
  computed: {
    ...mapGetters({
      languages: AVAILABLE_LANGUAGES,
    }),
    filteredLanguages() {
      return this.languages.filter(lang => lang !== this.lang);
    },
  },
  methods: {
    ...mapActions({
      setLanguage: LANGUAGE,
    }),
  },
};
</script>

<style lang="scss">
.locale-selector {
  text-align: center;

  &__separator {
    margin: 0 $global-margin / 2;
    color: $black;
  }
}
</style>
